import type { ReactElement } from 'react';
import type { ActivityRow } from '../../domain/activityLog';

export function ActivityTable({
  rows,
  loading,
  empty = 'No activity yet.',
  testId = 'activity-table'
}: {
  rows: ActivityRow[];
  loading?: boolean;
  empty?: string;
  testId?: string;
}): ReactElement {
  return (
    <section className="nested-card" aria-label="Activity" data-testid={testId}>
      <h4 className="form-section-title">Activity</h4>
      {loading ? (
        <p className="hint">Loading activity…</p>
      ) : (
        <table className="po-lines">
          <thead>
            <tr>
              <th>When</th>
              <th>Who</th>
              <th>Action</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={4} className="hint">
                  {empty}
                </td>
              </tr>
            ) : (
              rows.map((row) => (
                <tr key={row.id}>
                  <td>{row.occurredAtUtc ? new Date(row.occurredAtUtc).toLocaleString() : '—'}</td>
                  <td>{row.actor || '—'}</td>
                  <td>
                    <span className="status-pill">{row.action}</span>
                  </td>
                  <td>{row.description || '—'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </section>
  );
}
